import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import { alpha } from '@mui/material/styles';

const styles = theme => ({
    link: {
        ...theme.style.link,
        // Pas d'outline de focus : la sélection est déjà marquée par le fond coloré + le liseré gauche.
        // (évite les 2 bandes orange qui restaient après clic sur un item du drawer)
        '&:focus': {
            outline: 'none'
        }
    },

    listItem: {
        paddingRight: 8,
        paddingLeft: 12,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },

    listItemSelected: {
        boxShadow: 'inset 4px 0 0 ' + theme.palette.selected,
        backgroundColor: alpha(theme.palette.selected, 0.08),
        '&:hover': {
            backgroundColor: alpha(theme.palette.selected, 0.12)
        }
    },

    listItemIcon: {
        margin: 0,
        padding: 0
    },

    selected: {
        color: theme.palette.selected
    }
});

const ReclamationDrawerListItem = ({ classes, title, href, icon, isSelected, disable }) => {
    let listItem = (
        <ListItem className={classNames(classes.listItem, isSelected && classes.listItemSelected)} disabled={disable}>
            <ListItemIcon className={classNames(classes.listItemIcon, isSelected && classes.selected)}>
                {icon}
            </ListItemIcon>

            <ListItemText
                primary={title}
                primaryTypographyProps={{
                    className: isSelected ? classes.selected : null
                }}
            />
        </ListItem>
    );

    if (disable)
        return listItem;

    return (
        <Link to={href} className={classes.link}>
            {listItem}
        </Link>
    );
};

ReclamationDrawerListItem.propTypes = ({
    classes: PropTypes.object.isRequired,

    title: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,

    isSelected: PropTypes.bool.isRequired,
    disable: PropTypes.bool
});

export default withStyles(styles)(ReclamationDrawerListItem);